export default __webpack_public_path__ + "f7621b2a.png";